import { CForm, CFormInput } from "@coreui/react";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { t } from 'i18next';
import { useNavigate, useParams } from "react-router-dom";
import { useSpinner } from "@webkit/components/typescript/SpinnerContext";
import { getToastStore } from "@utils/ToastStore";
import cardLocationService from "@services/cardLocation.service";
import accomodationService from "@services/accomodation.service";
import { errorToast, successToast } from "@webkit/functions/utils";


export default function EditCardLocationPage() {
  const ctxToast = getToastStore();
  const { showSpinner, hideSpinner } = useSpinner();
  const navigate = useNavigate();
  const { parentId, cardId } = useParams(); // id dell'accommodation

  const [fullAddress, setFullAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");

  const [latitude, setLatitude] = useState<number>(0);
  const [longitude, setLongitude] = useState<number>(0);

  const isDisabledClean = !fullAddress.trim() && !city.trim() && !country.trim();
  const isDisabledValidate = !(!!fullAddress && !!city && !!country) || (!!latitude && !!longitude)

  /** -------------------------------
   *   FETCH DATI PRE-POPOLATI
   *  ------------------------------*/
  useEffect(() => {
    const fetchLocation = async () => {
      if (!parentId) return;

      showSpinner();
      try {
        const res = await cardLocationService.getLocationByAccomodationId(Number(parentId));
        setFullAddress(res.fullAddress);
        setCity(res.city);
        setCountry(res.country);

      } catch (err) {
        console.error(err);
        if (ctxToast) {
          ctxToast.setToastMsg(t("error.data_not_found"));
          ctxToast.setSeeToast(true);
          ctxToast.setErrorToast(true);
        }
      } finally {
        hideSpinner();
      }
    };

    fetchLocation();
  }, [parentId]);

  /** -------------------------------
   *   VALIDATE COORDINATE
   *  ------------------------------*/
  const handleValidate = async () => {
    showSpinner();

    try {
      const params = {
        street: fullAddress,
        city: city,
        country: country,
        polygon_geojson: 1,
        format: "jsonv2"
      };

      const response = await accomodationService.getLongitudeAndLatitude(params);

      if (response.length === 0 && ctxToast) {
        ctxToast.setToastMsg("Indirizzo non trovato.");
        ctxToast.setSeeToast(true);
        ctxToast.setErrorToast(true);
        return;
      }

      const first = response[0];

      if (!!first.lat && !!first.lon) {
        setLatitude(parseFloat(first.lat));
        setLongitude(parseFloat(first.lon));
        successToast(ctxToast, t("success.address_valid"))
      } else {
        errorToast(ctxToast, t("error.not_found_coordinates"))
      }
    } catch (err) {
      errorToast(ctxToast, t("error.validation_error"))
    } finally {
      hideSpinner();
    }
  };

  /** -------------------------------
   *   UPDATE BACKEND
   *  ------------------------------*/
  const handleSave = async () => {

    if (!parentId) return;

    showSpinner();
    try {

      await cardLocationService.updateLocationCard(parentId, {
        fullAddress: fullAddress.trim(),
        city: city.trim(),
        country: country.trim(),
        latitude,
        longitude
      });

      successToast(ctxToast,t("success.updated"))
      navigate(`/new-app/${parentId}`);

    } catch (err) {
      errorToast(ctxToast,t("error.update_failed"))
    } finally {
      hideSpinner();
    }
  };

  /** -------------------------------
   *   RESET CAMPi
   *  ------------------------------*/
  const handleClean = () => {
    setFullAddress("");
    setCity("");
    setCountry("");
    setLatitude(0);
    setLongitude(0);
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="card shadow-lg" style={{ width: "70%", borderRadius: "25px" }}>
        <div className="hst-card-header card-header text-uppercase">
          {t("label.edit_location")}
        </div>

        <div className="card-body">
          <CForm className="p-5">

            <CFormInput
              type="text"
              label={`${t("label.full_address")} ${t('placeholder.obligatory')}`}
              className="mb-3"
              value={fullAddress}
              onChange={(e) => setFullAddress(e.target.value)}
              disabled={!!latitude && !!longitude}
            />

            <CFormInput
              type="text"
              label={`${t("label.city")} ${t('placeholder.obligatory')}`}
              className="mb-3"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              disabled={!!latitude && !!longitude}
            />

            <CFormInput
              type="text"
              label={`${t("label.country")} ${t('placeholder.obligatory')}`}
              className="mb-3"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              disabled={!!latitude && !!longitude}
            />

            <div className="d-flex gap-3 mt-4">
              <Button
                className="hst-btn-primary"
                onClick={handleValidate}
                disabled={isDisabledValidate}
              >
                {t("button.validate")}
              </Button>

              <Button
                className="hst-btn-clean"
                onClick={handleClean}
                disabled={isDisabledClean}
              >
                {t("button.clean")}
              </Button>
            </div>

          </CForm>
        </div>
        <div
          className="card-footer bg-transparent w-100"
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: "20px" }}
        >
          <Button
            className="hst-btn-secondary"
            onClick={() => navigate(-1)}
          >
            {t('text.go_back')}
          </Button>

          <Button
            className="text-uppercase hst-btn-primary"
            onClick={handleSave}
            disabled={!latitude && !longitude}
            style={{fontWeight:"500"}}
          >
            {t('button.save')}
          </Button>
        </div>
      </div>
    </div>
  );
}
